// The interstitial: this browser can't open the quote as it arrived — the
// credential named someone else's link, was already spent, or never
// existed at all. Full-page, under the same header as the flow. A lead
// still awaiting confirmation and everyone else get the re-entry screen,
// which sends a code or link to get back in.
// (Analytics: the flow's `quote_flow_screen_viewed {screen: interstitial,
// reason}` already marks this moment; the re-entry screen reports its own.)

import { SUPPORT_PHONE_HREF, SUPPORT_PHONE_LABEL } from "constants/phones";

import type { QuoteType } from "./analytics";
import ReentryScreen from "./ReentryScreen";

/** Which channel the browser arrived through — the flow's `credential`
 * analytics prop; the interstitial's copy itself keys on the refusal code. */
export type InterstitialCredential = "link" | "signature" | "none";

export interface AuthInterstitialProps {
  quoteId: string;
  /** The 409 body's `error` code, or "no_credential" for a bare arrival
   * with nothing to present. */
  reason: string;
  /** The URL's one-time link as it arrived. */
  linkToken: string | null;
  subject: QuoteType;
  /** The quote stayed closed after the visitor proved an email or phone. */
  closedAfterProof: boolean;
  /** A code has signed the visitor in and the quote should be tried again. */
  onSignedIn: () => void;
  /** The line to call: the pre-need line unless the station says otherwise. */
  supportLine?: { href: string; label: string };
}

const PRE_NEED_LINE = { href: SUPPORT_PHONE_HREF, label: SUPPORT_PHONE_LABEL };

export default function AuthInterstitial({
  supportLine = PRE_NEED_LINE,
  ...props
}: AuthInterstitialProps) {
  return <ReentryScreen {...props} supportLine={supportLine} />;
}
